var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('info-screen',{staticClass:"startRegistration",attrs:{"title":_vm.$ml.get('setFinishTitleReg'),"text":_vm.textInfo,"action":_vm.nextScreen,"buttonText":_vm.$ml.get('setFinishButtonReg'),"titleH1":"","headerImg":8}})}
var staticRenderFns = []

export { render, staticRenderFns }